/**
 * Axios configuration for Gewaer's CRM API
 * @module CrmAPI
 *
 * This a private API in the gewaer/kanvas organization
 * The purpose is to retrieve information of companies, feeds, leads, among others
 */

import axios from 'axios';

/**
 * Appends the `lang` and `headers` browser metadata into every request
 * @param {object} config Axios request config object. See also {@link https://github.com/axios/axios#request-config}
 * @returns {object} Axios request config object with the metadata appended
 */
function appendingBrowserMetadata(config) {
  if (config.data && config.data.message) {
    return {
      ...config,
      data: {
        ...config.data,
        message: {
          ...config.data.message,
          lang: navigator.language,
          headers: {
            'User-Agent': navigator.userAgent,
          },
        },
      },
    };
  }
  return config;
}

const instance = axios.create({
  baseURL: `${process.env.VUE_APP_API_URL_GEWAER}/v2`,
});

instance.interceptors.request.use(appendingBrowserMetadata);

export default instance;
